import Vue from 'vue'
import { SET_PAGE_HEADER } from '../mutation-types'
import pageHeaderService from '../services/page_headers'

// The only query keys that decide which products-page header shows. Other
// filters (colour, availability, page…) never change it, so they stay out of
// the cache key and don't trigger refetches.
export const HEADER_QUERY_KEYS = ['module', 'brand', 'sub_brand', 'department', 'category']

export function headerParams (query = {}) {
  return HEADER_QUERY_KEYS.reduce((params, key) => {
    const value = query[key]
    if (value !== undefined && value !== null && value !== '') {
      params[key] = Array.isArray(value) ? value.join(',') : String(value)
    }
    return params
  }, {})
}

export function headerKey (params) {
  return Object.keys(params).sort().map(key => `${key}=${params[key]}`).join('&')
}

// A free-text search is not a classification node: it reads as its own header and
// replaces any node header, however many taxonomy filters sit alongside it. Deliberately
// out of HEADER_QUERY_KEYS — the term is decided from the URL, so it needs neither a
// round-trip nor a cache entry, and every distinct term would otherwise be a cache miss.
export function filterSearchHeader (query = {}) {
  const term = typeof query.search === 'string' ? query.search.trim() : ''

  return term ? { parent: 'Filter Search:', title: term, description: null, quick_links: [] } : null
}

// "Clear Search Results" removes the search constraint but keeps the facets — the inverse
// of FilterButton.clearFilters(), which keeps search and drops facets. `page` goes too, so
// the larger facet-only result set starts at page 1 rather than a stale out-of-range page.
export function withoutSearch (query = {}) {
  const { search, page, ...rest } = query

  return rest
}

// Headers are cached per query for the session, so returning to a page shows
// its header at once while a fresh copy loads. Each response lands under its
// own key, so a slow reply for a previous page can never overwrite this one.
export const state = {
  byKey: {}
}

export const getters = {
  headerFor: state => params => state.byKey[headerKey(headerParams(params))] || null
}

export const mutations = {
  [SET_PAGE_HEADER] (state, { key, header }) {
    Vue.set(state.byKey, key, header)
  }
}

export const actions = {
  async fetchHeader ({ commit }, query) {
    const params = headerParams(query)
    const { data } = await pageHeaderService.resolve(params)
    commit(SET_PAGE_HEADER, { key: headerKey(params), header: data.data })
    return data.data
  }
}
